export default {
  id: 'warehouse',
  title: 'Skladište',
  icon: 'mdi-warehouse',
  badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
  show: true,
  order: 13,
  children: [
    {
      id: 'warehouse-overview',
      title: 'Modul skladišta - Pregled',
      icon: 'mdi-information',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2>Modul skladišta - Pregled</h2>
        <div class="warning-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <strong>Napomena:</strong> Modul skladišta je dostupan samo korisnicima sa aktiviranim skladišnim modulom.
        </div>

        <p>
          Modul skladišta omogućava naprednoano upravljanje zalihama, skladišnim dokumentima,
          dobavljačima i inventurom.
        </p>

        <h3 class="mt-4">Glavne funkcionalnosti</h3>
        <ul>
          <li><strong>Praćenje stanja zaliha</strong> - Uvid u trenutno stanje svih artikala</li>
          <li><strong>Skladišni dokumenti</strong> - Primke, izdatnice, međuskladišnice</li>
          <li><strong>Dobavljači</strong> - Upravljanje dobavljačima i njihovim katalozima</li>
          <li><strong>Inventura</strong> - Potpuna ili parcijalna inventura</li>
          <li><strong>Skladišna kartica</strong> - Povijest kretanja artikla</li>
          <li><strong>Normativ</strong> - Recepti za složene proizvode</li>
        </ul>

        <h3 class="mt-4">Aktivacija modula</h3>
        <p>
          Modul skladišta se aktivira u postavkama firme. Nakon aktivacije, potrebno je
          konfigurirati početno stanje zaliha.
        </p>
      `
    },
    {
      id: 'warehouse-items',
      title: 'Stanje skladišta',
      icon: 'mdi-package-variant',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="warehouse-stock">Stanje skladišta</h2>
        <p>Pregled trenutnih količina svih artikala na skladištima.</p>

        <h3 class="mt-4">Pristup</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Stanje skladišta"</strong></li>
          <li>Prikazuje se tablica sa svim artiklima i količinama</li>
        </ol>

        <h3 class="mt-4">Prikazani podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Skladište</th>
              <th>Trenutno stanje</th>
              <th>Min. zaliha</th>
              <th>Rezervirano</th>
              <th>Dostupno</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>Glavno skladište</td>
              <td>150 kom</td>
              <td>50 kom</td>
              <td>10 kom</td>
              <td>140 kom</td>
            </tr>
          </tbody>
        </table>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Upozorenje:</strong> Artikli sa stanjem ispod minimalne zalihe su označeni crvenom bojom!
          </div>
        </div>

        <h3 class="mt-4">Filtriranje</h3>
        <ul>
          <li><strong>Skladište</strong> - Prikaz za određeno skladište</li>
          <li><strong>Kategorija</strong> - Filtriraj po kategoriji</li>
          <li><strong>Status</strong> - Ispod minimuma, Dostupno, Nedostupno</li>
        </ul>

        <h3 class="mt-4">Akcije</h3>
        <ul>
          <li><i class="mdi mdi-history"></i> <strong>Skladišna kartica</strong> - Povijest kretanja artikla</li>
          <li><i class="mdi mdi-package-down"></i> <strong>Primka</strong> - Kreiranje primke za narudžbu</li>
          <li><i class="mdi mdi-package-up"></i> <strong>Izdatnica</strong> - Izdavanje sa skladišta</li>
        </ul>
      `
    },
    {
      id: 'warehouse-documents',
      title: 'Skladišni dokumenti',
      icon: 'mdi-file-document-multiple',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="warehouse-docs">Skladišni dokumenti</h2>
        <p>Pregled svih skladišnih dokumenata: primke, izdatnice, međuskladišnice.</p>

        <h3 class="mt-4">Tipovi dokumenata</h3>
        <ul>
          <li><strong>Primka (GRN)</strong> - Primitak robe od dobavljača</li>
          <li><strong>Izdatnica (GIN)</strong> - Izdavanje robe (kalo, škart, prodaja)</li>
          <li><strong>Međuskladišnica</strong> - Prijenos između skladišta</li>
          <li><strong>Inventurni list</strong> - Usklađivanje stvarnog sa knjigovodstvenim stanjem</li>
        </ul>

        <h3 class="mt-4">Pristup dokumentima</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Dokumenti"</strong></li>
          <li>Odaberite tip dokumenta iz tab-ova</li>
          <li>Prikazuje se lista svih dokumenata</li>
        </ol>

        <h3 class="mt-4">Pregled dokumenta</h3>
        <p>Za svaki dokument vidite:</p>
        <ul>
          <li><strong>Broj dokumenta</strong> - Jedinstveni broj (npr. GRN-2025-001)</li>
          <li><strong>Datum</strong> - Kada je dokument kreiran</li>
          <li><strong>Skladište</strong> - Koje skladište</li>
          <li><strong>Dobavljač/Primatelj</strong> - S kim se odvija transakcija</li>
          <li><strong>Status</strong> - Draft, Knjiženo, Stornirano</li>
          <li><strong>Ukupna vrijednost</strong> - Vrijednost dokument</li>
        </ul>

        <h3 class="mt-4">Knjiženje dokumenta</h3>
        <ol>
          <li>Kliknite na dokument u statusu "Draft"</li>
          <li>Provjerite artikle i količine</li>
          <li>Kliknite <strong>"Knjiži dokument"</strong></li>
          <li>Stanje skladišta se automatski ažurira</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Nakon knjiženja dokument se NE MOŽE mijenjati! Za ispravke koristite storno ili novi dokument.
          </div>
        </div>

        <h3 class="mt-4">Izvoz dokumenata</h3>
        <ul>
          <li><strong>PDF</strong> - Za ispis ili slanje dobavljaču</li>
          <li><strong>Excel</strong> - Za analizu</li>
        </ul>
      `
    },
    {
      id: 'warehouse-grn',
      title: 'Primka (GRN)',
      icon: 'mdi-package-down',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="what-is">Što je primka (GRN)?</h2>
        <p><strong>Primka (Goods Received Note - GRN)</strong> je skladišni dokument koji se koristi za evidentiranje ulaska robe na skladište. Primka povećava stanje zaliha i obavezna je za praćenje nabave i troškova.</p>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>GRN = Goods Received Note</strong> (Dokument o primitku robe)
            <br><br>
            U RH poznat kao <strong>Primka</strong> ili <strong>Ulazni skladišni dokument</strong>.
          </div>
        </div>

        <h2 id="when-to-use" class="mt-6">Kada koristiti primku?</h2>
        <ul>
          <li>Pri primitku robe od dobavljača</li>
          <li>Kod povrata robe od kupca (reklamacija)</li>
          <li>Pri inventuri - korekcija stanja na više</li>
          <li>Vlastita proizvodnja (gotovi proizvodi)</li>
          <li>Početno stanje zaliha (pri postavljanju sustava)</li>
        </ul>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Aktiviran modul skladišta</li>
          <li>Pristup "Skladište" → "Primke"</li>
          <li>Artikli kreirani u sustavu</li>
          <li>Dobavljač kreiran (ako je primitak od dobavljača)</li>
        </ul>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Kreiranje nove primke</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Primke"</strong></li>
          <li>Kliknite <strong>"+ Nova primka"</strong> ili <strong>"Kreiraj GRN"</strong></li>
          <li>Otvara se forma za unos primke</li>
        </ol>

        <h3 class="mt-4">2. Osnovni podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno?</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Datum</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Datum primitka robe (automatski postavljeno na danas)</td>
            </tr>
            <tr>
              <td><strong>Skladište</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Na koje skladište roba ulazi</td>
            </tr>
            <tr>
              <td><strong>Dobavljač</strong></td>
              <td><span class="status-chip warning">PREPORUČENO</span></td>
              <td>Od koga primamo robu</td>
            </tr>
            <tr>
              <td><strong>Broj računa dobavljača</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Referentni broj dobavljačevog računa/otpremnice</td>
            </tr>
            <tr>
              <td><strong>Napomena</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Dodatne informacije (npr. "Tjedna dostava", "Hitno")</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Dodavanje artikala</h3>
        <p>Postoje 2 načina dodavanja artikala na primku:</p>

        <h4 style="font-size: 15px; margin-top: 16px;">
          <i class="mdi mdi-numeric-1-circle" style="color: #3989C9; margin-right: 8px;"></i>
          Ručno dodavanje (za manje količine)
        </h4>
        <ol>
          <li>Kliknite <strong>"+ Dodaj stavku"</strong></li>
          <li>Pretražite i odaberite artikl</li>
          <li>Unesite <strong>količinu</strong></li>
          <li>Unesite <strong>nabavnu cijenu</strong> (cijena po kojoj kupujete od dobavljača)</li>
          <li>Sustav automatski računa ukupno</li>
        </ol>

        <h4 style="font-size: 15px; margin-top: 16px;">
          <i class="mdi mdi-numeric-2-circle" style="color: #3989C9; margin-right: 8px;"></i>
          Barcode scanner (za veće količine)
        </h4>
        <ol>
          <li>Postavite kursor u polje "Skeniraj barcode"</li>
          <li>Skenirajte barcode artikla</li>
          <li>Sustav automatski dodaje artikl</li>
          <li>Unesite količinu i nabavnu cijenu</li>
          <li>Ponavljajte za sljedeće artikle</li>
        </ol>

        <h3 class="mt-4">4. Nabavna cijena - Važno!</h3>
        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Nabavna cijena nije prodajna cijena!</strong>
            <br><br>
            <strong>Nabavna cijena</strong> = Po kojoj cijeni KUPUJETE robu (od dobavljača)<br>
            <strong>Prodajna cijena</strong> = Po kojoj PRODAJETE kupcu (na cjeniku)
            <br><br>
            <strong>Primjer:</strong> Nabavljate Coca Colu za 1,50 €, a prodajete za 2,50 €
          </div>
        </div>

        <table class="info-table">
          <thead>
            <tr>
              <th>Cijena</th>
              <th>Gdje se unosi</th>
              <th>Svrha</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Nabavna</strong></td>
              <td>Na primki (GRN)</td>
              <td>Praćenje troškova, kalkulacija marže</td>
            </tr>
            <tr>
              <td><strong>Prodajna</strong></td>
              <td>Na cjeniku</td>
              <td>Cijena za kupce na blagajni</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">5. Pregled i kontrola</h3>
        <ol>
          <li>Provjerite sve stavke na primci</li>
          <li>Provjerite ukupnu vrijednost (suma svih stavki)</li>
          <li>Usporedite s dobavljačevim računom/otpremnicom</li>
          <li>Ispravite eventualne greške</li>
        </ol>

        <h3 class="mt-4">6. Knjiženje primke</h3>
        <ol>
          <li>Kada su svi podaci točni, kliknite <strong>"Knjižim"</strong> ili <strong>"Zatvori primku"</strong></li>
          <li>Status primke se mijenja na <span class="status-chip success">Knjiženo</span></li>
          <li>Stanje artikala na skladištu se <strong>povećava</strong> za unesene količine</li>
          <li>Primka više nije moguće mijenjati (trajna)</li>
        </ol>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <strong>Važno:</strong> Prije knjiženja, primka ima status <span class="status-chip warning">Nacrt</span> i može se uređivati. Nakon knjiženja, nije moguće brisanje ili izmjena!
        </div>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Primke u nacrtu:</strong> Možete kreirati primku kao nacrt i knjižiti je kasnije nakon fizičke provjere robe</li>
          <li><strong>Troškovi dostave:</strong> Dodajte stavku "Transport" ili uključite u cijenu artikala</li>
          <li><strong>Težinski artikli:</strong> Za artikle koji se prodaju po kg (npr. meso), pazite na decimalnu točnost</li>
          <li><strong>PDV na nabavi:</strong> Nabavna cijena obično NE uključuje PDV (ovisno o postavkama)</li>
          <li><strong>Batch broj:</strong> Ako radite s šaržama/batch brojevima, unesite ih u napomenu</li>
          <li><strong>Rok trajanja:</strong> Za artikle s rokom, zabilježite datum isteka</li>
        </ul>

        <h2 id="warehouse-states" class="mt-6">Kako primka utječe na stanje?</h2>
        <p>Primjer knjiženja primke:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Stanje prije</th>
              <th>Primka</th>
              <th>Stanje poslije</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>50 kom</td>
              <td>+100 kom</td>
              <td><strong>150 kom</strong></td>
            </tr>
            <tr>
              <td>Kava zrno 1kg</td>
              <td>5 kg</td>
              <td>+20 kg</td>
              <td><strong>25 kg</strong></td>
            </tr>
          </tbody>
        </table>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Ne mogu pronaći dobavljača u listi?</summary>
          <p>Dobavljač mora biti prethodno kreiran:</p>
          <ol>
            <li>Idite na "Skladište" → "Dobavljači"</li>
            <li>Kliknite "+ Dodaj dobavljača"</li>
            <li>Unesite osnovne podatke (naziv, OIB, adresa)</li>
            <li>Spremite</li>
            <li>Vratite se na primku i odaberite dobavljača</li>
          </ol>
        </details>

        <details>
          <summary>Slučajno sam knjižio primku s pogrešnim podacima?</summary>
          <p>Nakon knjiženja, primka se ne može mijenjati ni brisati:</p>
          <ul>
            <li><strong>Opcija 1 (preporučeno):</strong> Kreirajte <strong>storno primku</strong> (negativne količine) da poništite grešku</li>
            <li><strong>Opcija 2:</strong> Kontaktirajte administratora za ručnu intervenciju</li>
            <li><strong>Opcija 3:</strong> Koristite izdatnicu (GIN) za izlaz greške, zatim novu primku za ispravan unos</li>
          </ul>
        </details>

        <details>
          <summary>Primio sam manje robe nego što piše na otpremnici?</summary>
          <p>Unesite STVARNO primljenu količinu, ne onu s dokumenta:</p>
          <ol>
            <li>Na primku upišite samo ono što ste fizički primili</li>
            <li>U napomenu napišite: "Primljeno 80 od 100 kom - reklamacija u tijeku"</li>
            <li>Kontaktirajte dobavljača za dopunu ili povrat novca</li>
            <li>Kada stigne dopuna, kreirajte novu primku za preostalu količinu</li>
          </ol>
        </details>

        <details>
          <summary>Trebam li raditi primku za svaku dostavu?</summary>
          <p>Da! Primka je obavezna za:</p>
          <ul>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Svaki primitak robe od dobavljača</li>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Povrat robe od kupca</li>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Vlastitu proizvodnju</li>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Korekcije inventure (višak)</li>
          </ul>
          <p>Bez primke, stanje skladišta neće biti točno!</p>
        </details>

        <details>
          <summary>Što ako ne znam nabavnu cijenu?</summary>
          <p>Nabavna cijena je važna za izvještavanje:</p>
          <ul>
            <li>Provjerite dobavljačev račun ili otpremnicu</li>
            <li>Ako nemate podatak, unesite procijenjenu vrijednost</li>
            <li>Kasnije možete korigirati kroz "Skladišna kartica"</li>
            <li>Za točne izvještaje marže, nabavna cijena mora biti ispravna</li>
          </ul>
        </details>

        <details>
          <summary>Mogu li uvesti primku iz CSV/Excel datoteke?</summary>
          <p>Ovisno o sustavu:</p>
          <ul>
            <li>Neki sustavi podržavaju uvoz primki iz CSV-a</li>
            <li>Provjerite je li dostupan gumb "Uvoz" ili "Import" na stranici primki</li>
            <li>Format CSV-a obično zahtijeva: artikl_id, količina, cijena</li>
            <li>Kontaktirajte podršku za točan format i upute</li>
          </ul>
        </details>

        <details>
          <summary>Kako stornirati (poništiti) primku?</summary>
          <p>Primka se ne briše, već <strong>stornira</strong>:</p>
          <ol>
            <li>Idite na "Skladište" → "Primke"</li>
            <li>Pronađite primku koju želite stornirati</li>
            <li>Kliknite "..." → "Storniraj" ili "Kreiraj storno"</li>
            <li>Sustav automatski kreira negativnu primku</li>
            <li>Knjižite storno primku</li>
            <li>Stanje se vraća na prethodno</li>
          </ol>
        </details>
      `
    },
    {
      id: 'warehouse-gin',
      title: 'Izdatnica (GIN)',
      icon: 'mdi-package-up',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="what-is">Što je izdatnica (GIN)?</h2>
        <p><strong>Izdatnica (Goods Issue Note - GIN)</strong> je skladišni dokument koji evidentira izlaz robe sa skladišta. Izdatnica smanjuje stanje zaliha i koristi se za otpis, kvar, trošak ili transfer robe.</p>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>GIN = Goods Issue Note</strong> (Dokument o izdavanju robe)
            <br><br>
            U RH poznat kao <strong>Izdatnica</strong> ili <strong>Izlazni skladišni dokument</strong>.
          </div>
        </div>

        <h2 id="when-to-use" class="mt-6">Kada koristiti izdatnicu?</h2>
        <ul>
          <li>Otpis robe (pokvarena, istekla, oštećena)</li>
          <li>Trošak za vlastitu potrošnju (degustacija, testiranje)</li>
          <li>Izdavanje robe za proizvodnju</li>
          <li>Povrat robe dobavljaču (reklamacija)</li>
          <li>Korekcija stanja nakon inventure (manjak)</li>
          <li>Izlaz robe koji nije preko blagajne</li>
        </ul>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Prodaja robe preko blagajne <strong>automatski</strong> smanjuje stanje - nije potrebna izdatnica!
          </div>
        </div>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Aktiviran modul skladišta</li>
          <li>Pristup "Skladište" → "Izdatnice"</li>
          <li>Artikli koji postoje na skladištu (dovoljno stanja)</li>
        </ul>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Kreiranje nove izdatnice</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Izdatnice"</strong></li>
          <li>Kliknite <strong>"+ Nova izdatnica"</strong> ili <strong>"Kreiraj GIN"</strong></li>
          <li>Otvara se forma za unos</li>
        </ol>

        <h3 class="mt-4">2. Osnovni podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno?</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Datum</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Datum izlaza robe</td>
            </tr>
            <tr>
              <td><strong>Skladište</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Sa kojeg skladišta roba izlazi</td>
            </tr>
            <tr>
              <td><strong>Tip izdatnice</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Razlog izlaza (otpis, trošak, povrat, proizvodnja)</td>
            </tr>
            <tr>
              <td><strong>Napomena</strong></td>
              <td><span class="status-chip warning">PREPORUČENO</span></td>
              <td>Razlog otpisa/troška (npr. "Istekao rok", "Oštećeno pakiranje")</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Tipovi izdatnice</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Tip</th>
              <th>Kada koristiti</th>
              <th>Primjer</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Otpis</strong></td>
              <td>Roba se odbacuje (kvar, istek, šteta)</td>
              <td>"5 kg mesa - istekao rok trajanja"</td>
            </tr>
            <tr>
              <td><strong>Trošak</strong></td>
              <td>Vlastita potrošnja</td>
              <td>"2 kave za degustaciju kupaca"</td>
            </tr>
            <tr>
              <td><strong>Proizvodnja</strong></td>
              <td>Sirovine za proizvodnju gotovih proizvoda</td>
              <td>"10 kg brašna za pekarnicu"</td>
            </tr>
            <tr>
              <td><strong>Povrat dobavljaču</strong></td>
              <td>Reklamacija kvalitete</td>
              <td>"20 kom oštećenih boca"</td>
            </tr>
            <tr>
              <td><strong>Korekcija</strong></td>
              <td>Inventurni manjak</td>
              <td>"Manjak nakon inventure"</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">4. Dodavanje artikala</h3>
        <ol>
          <li>Kliknite <strong>"+ Dodaj stavku"</strong></li>
          <li>Pretražite i odaberite artikl</li>
          <li>Unesite <strong>količinu</strong> koja izlazi</li>
          <li>Sustav provjerava ima li dovoljno stanja na skladištu</li>
          <li>Dodajte sve stavke koje trebate izdati</li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Provjera stanja:</strong> Ne možete izdati više nego što imate na skladištu! Sustav će upozoriti ako je stanje nedovoljno.
          </div>
        </div>

        <h3 class="mt-4">5. Knjiženje izdatnice</h3>
        <ol>
          <li>Provjerite sve stavke</li>
          <li>Kliknite <strong>"Knjižim"</strong></li>
          <li>Status: <span class="status-chip success">Knjiženo</span></li>
          <li>Stanje skladišta se <strong>smanjuje</strong></li>
          <li>Izdatnica više nije moguće mijenjati</li>
        </ol>

        <h2 id="warehouse-states" class="mt-6">Kako izdatnica utječe na stanje?</h2>
        <p>Primjer knjiženja izdatnice:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Stanje prije</th>
              <th>Izdatnica</th>
              <th>Stanje poslije</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>150 kom</td>
              <td>-20 kom (otpis)</td>
              <td><strong>130 kom</strong></td>
            </tr>
            <tr>
              <td>Kava zrno 1kg</td>
              <td>25 kg</td>
              <td>-5 kg (trošak)</td>
              <td><strong>20 kg</strong></td>
            </tr>
          </tbody>
        </table>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Dokumentiranje:</strong> Uvijek unesite razlog u napomenu (važno za reviziju)</li>
          <li><strong>Fotografije:</strong> Za veće otpise, fotografirajte robu prije odlaganja</li>
          <li><strong>Odobrenje:</strong> Za veće iznose, zatražite odobrenje menadžera</li>
          <li><strong>Razlikovanje:</strong> Prodaja preko blagajne ≠ Izdatnica. Izdatnica je samo za izlaze koji nisu prodaja</li>
          <li><strong>Redovna provjera:</strong> Pregledavajte izdatnice mjesečno radi kontrole troškova</li>
        </ul>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Greška "Nedovoljno stanja na skladištu"?</summary>
          <p>Ne možete izdati više nego što imate:</p>
          <ol>
            <li>Provjerite trenutno stanje u "Stanje skladišta"</li>
            <li>Smanjite količinu na izdatnici</li>
            <li>Ili prvo kreirajte primku za dodatnu robu</li>
          </ol>
        </details>

        <details>
          <summary>Trebam li raditi izdatnicu za prodaju na blagajni?</summary>
          <p><strong>NE!</strong> Prodaja preko blagajne automatski ažurira stanje:</p>
          <ul>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> Prodaja na blagajni → automatski izlaz sa skladišta</li>
            <li><i class="mdi mdi-close" style="color: #F44336; margin-right: 4px;"></i> Izdatnicu radite SAMO za izlaze koji NISU prodaja</li>
          </ul>
        </details>

        <details>
          <summary>Slučajno sam knjižio pogrešnu izdatnicu?</summary>
          <p>Nakon knjiženja nije moguće brisanje:</p>
          <ul>
            <li><strong>Rješenje:</strong> Kreirajte <strong>storno izdatnicu</strong> (negativne količine)</li>
            <li>Ili napravite primku s istim količinama da vratite stanje</li>
          </ul>
        </details>

        <details>
          <summary>Koji je razlika između otpisa i troška?</summary>
          <table class="info-table">
            <thead>
              <tr>
                <th>Otpis</th>
                <th>Trošak</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Roba se odbacuje/uništava</td>
                <td>Roba se koristi interno</td>
              </tr>
              <tr>
                <td>Primjer: Istekao rok, kvar</td>
                <td>Primjer: Degustacija, testiranje</td>
              </tr>
              <tr>
                <td>Gubitak</td>
                <td>Ulaganje u marketing/kvalitetu</td>
              </tr>
            </tbody>
          </table>
        </details>

        <details>
          <summary>Treba li računovodstvu dostaviti izdatnice?</summary>
          <p>Da, izdatnice su važne za:</p>
          <ul>
            <li>Praćenje troškova i gubitaka</li>
            <li>Poreznu evidenciju</li>
            <li>Reviziju i kontrolu</li>
          </ul>
          <p>Izvezite izvještaj izdatnica mjesečno i dostavite računovodstvu.</p>
        </details>
      `
    },
    {
      id: 'warehouse-transfer',
      title: 'Međuskladišnica',
      icon: 'mdi-swap-horizontal',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="what-is">Što je međuskladišnica?</h2>
        <p><strong>Međuskladišnica</strong> je skladišni dokument za premještanje robe između dva skladišta. Roba izlazi s jednog skladišta i ulazi na drugo, uz očuvanje ukupnog stanja u sustavu.</p>

        <h2 id="when-to-use" class="mt-6">Kada koristiti međuskladišnicu?</h2>
        <ul>
          <li>Transfer robe između skladišta na različitim lokacijama</li>
          <li>Premještanje iz centralnog skladišta u prodavaonice</li>
          <li>Balansiranje zaliha između lokacija</li>
          <li>Prijevoz robe između odjela (kuhinja ↔ šank)</li>
        </ul>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Minimalno 2 skladišta kreirana u sustavu</li>
          <li>Pristup "Skladište" → "Međuskladišnice"</li>
          <li>Dovoljno stanja na izlaznom skladištu</li>
        </ul>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Kreiranje međuskladišnice</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Međuskladišnice"</strong></li>
          <li>Kliknite <strong>"+ Nova međuskladišnica"</strong></li>
          <li>Otvara se forma za unos</li>
        </ol>

        <h3 class="mt-4">2. Osnovni podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno?</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Datum</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Datum transfera</td>
            </tr>
            <tr>
              <td><strong>Izlazno skladište</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>SA kojeg skladišta roba izlazi</td>
            </tr>
            <tr>
              <td><strong>Ulazno skladište</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>NA koje skladište roba ulazi</td>
            </tr>
            <tr>
              <td><strong>Napomena</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Razlog transfera (npr. "Popuna prodavaonice")</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Dodavanje artikala za transfer</h3>
        <ol>
          <li>Kliknite <strong>"+ Dodaj stavku"</strong></li>
          <li>Odaberite artikl</li>
          <li>Unesite količinu za transfer</li>
          <li>Sustav provjerava ima li dovoljno na izlaznom skladištu</li>
        </ol>

        <h3 class="mt-4">4. Knjiženje međuskladišnice</h3>
        <ol>
          <li>Provjerite sve stavke</li>
          <li>Kliknite <strong>"Knjižim"</strong></li>
          <li>Status: <span class="status-chip success">Knjiženo</span></li>
          <li>Izlazno skladište: stanje se <strong>smanjuje</strong></li>
          <li>Ulazno skladište: stanje se <strong>povećava</strong></li>
        </ol>

        <h2 id="warehouse-states" class="mt-6">Kako međuskladišnica utječe na stanje?</h2>
        <p>Primjer transfera između skladišta:</p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Skladište A (prije)</th>
              <th>Transfer</th>
              <th>Skladište A (poslije)</th>
              <th>Skladište B (poslije)</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>200 kom</td>
              <td>100 kom →</td>
              <td><strong>100 kom</strong></td>
              <td><strong>+100 kom</strong></td>
            </tr>
          </tbody>
        </table>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <strong>Važno:</strong> Ukupno stanje u sustavu ostaje isto! Samo se raspodjela mijenja između skladišta.
        </div>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Dokumentiranje prijevoza:</strong> Upišite u napomenu tko prevozi i kada</li>
          <li><strong>Prihvat robe:</strong> Osoba na ulaznom skladištu treba fizički provjeriti količinu</li>
          <li><strong>Redovni transferi:</strong> Kreirajte raspored (npr. svaki ponedjeljak centralno→prodavaonica)</li>
          <li><strong>Kontrola:</strong> Usporedite fizičko stanje nakon transfera</li>
        </ul>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Ne mogu odabrati isto skladište za izlaz i ulaz?</summary>
          <p>Izlazno i ulazno skladište moraju biti različita:</p>
          <ul>
            <li>Sustav sprječava odabir istog skladišta</li>
            <li>Za korekcije koristite primku ili izdatnicu</li>
          </ul>
        </details>

        <details>
          <summary>Primio sam manje robe nego što piše na međuskladišnici?</summary>
          <p>Fizička kontrola je važna:</p>
          <ol>
            <li>Kontaktirajte osobu koja je poslala robu</li>
            <li>Provjerite je li nešto izgubljeno u transportu</li>
            <li>Napravite korekciju izdatnicom na izlaznom skladištu za manjak</li>
          </ol>
        </details>

        <details>
          <summary>Kako stornirati međuskladišnicu?</summary>
          <ol>
            <li>Kreirajte novu međuskladišnicu u <strong>obrnutom smjeru</strong></li>
            <li>Ulazno → Izlazno postaje Izlazno → Ulazno</li>
            <li>Unesite iste količine</li>
            <li>Knjižite</li>
          </ol>
        </details>
      `
    },
    {
      id: 'warehouse-suppliers',
      title: 'Dobavljači',
      icon: 'mdi-truck',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="what-is">Što su dobavljači?</h2>
        <p><strong>Dobavljači</strong> su poslovni partneri od kojih nabavljate robu za skladište. Evidencija dobavljača omogućava praćenje nabave, cijena i kvalitete robe.</p>

        <h2 id="when-to-use" class="mt-6">Kada dodati dobavljača?</h2>
        <ul>
          <li>Prije kreiranja prve primke od tog dobavljača</li>
          <li>Kod sklapanja novog ugovora o nabavi</li>
          <li>Za organizaciju i praćenje svih izvora nabave</li>
        </ul>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Pristup "Skladište" → "Dobavljači"</li>
          <li>Podaci o dobavljaču (naziv, OIB, kontakt)</li>
        </ul>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Dodavanje novog dobavljača</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Dobavljači"</strong></li>
          <li>Kliknite <strong>"+ Dodaj dobavljača"</strong></li>
          <li>Otvara se forma za unos</li>
        </ol>

        <h3 class="mt-4">2. Osnovni podaci</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Polje</th>
              <th>Obavezno?</th>
              <th>Opis</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Naziv</strong></td>
              <td><span class="status-chip error">DA</span></td>
              <td>Ime tvrtke dobavljača</td>
            </tr>
            <tr>
              <td><strong>OIB</strong></td>
              <td><span class="status-chip warning">PREPORUČENO</span></td>
              <td>Identifikacijski broj (11 znamenki)</td>
            </tr>
            <tr>
              <td><strong>Adresa</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Puna adresa dobavljača</td>
            </tr>
            <tr>
              <td><strong>Kontakt osoba</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Ime osobe za kontakt</td>
            </tr>
            <tr>
              <td><strong>Telefon</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Broj telefona</td>
            </tr>
            <tr>
              <td><strong>Email</strong></td>
              <td><span class="status-chip grey">NE</span></td>
              <td>Email za narudžbe/komunikaciju</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">3. Dodatni podaci (opcionalno)</h3>
        <ul>
          <li><strong>Uvjeti plaćanja:</strong> Npr. "30 dana", "Odmah", "Po isporuci"</li>
          <li><strong>IBAN:</strong> Broj računa za plaćanje</li>
          <li><strong>Napomena:</strong> Slobodno polje za bilješke (npr. "Isporuka utorkom i petkom")</li>
          <li><strong>Status:</strong> Aktivan/Neaktivan</li>
        </ul>

        <h3 class="mt-4">4. Spremanje</h3>
        <ol>
          <li>Provjerite sve podatke</li>
          <li>Kliknite <strong>"Spremi"</strong></li>
          <li>Dobavljač je sada dostupan pri kreiranju primki</li>
        </ol>

        <h2 id="catalog" class="mt-6">Katalog artikala dobavljača</h2>
        <p>Neki sustavi podržavaju povezivanje artikala s dobavljačima:</p>
        <ol>
          <li>Otvorite dobavljača</li>
          <li>Idite na tab <strong>"Katalog"</strong></li>
          <li>Dodajte artikle koje ovaj dobavljač nudi</li>
          <li>Unesite dobavljačevu cijenu i šifru</li>
        </ol>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Prednost kataloga:</strong> Pri kreiranju primke možete brže dodavati artikle i vidjeti zadnje nabavne cijene.
          </div>
        </div>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Organizacija:</strong> Koristite jasne nazive (npr. "Metro Cash & Carry", "Dobavljač pića XYZ")</li>
          <li><strong>Kontakti:</strong> Uvijek unesite telefon i email za brzu komunikaciju</li>
          <li><strong>Uvjeti plaćanja:</strong> Zabilježite rok plaćanja u napomenu</li>
          <li><strong>Izvještavanje:</strong> Koristite izvještaje za analizu nabave po dobavljačima</li>
          <li><strong>Neaktivni dobavljači:</strong> Ne brišite stare dobavljače, označite ih kao neaktivne</li>
        </ul>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Mogu li imati istog dobavljača na više lokacija?</summary>
          <p>Da, dobavljači su obično zajednički za cijelu kompaniju:</p>
          <ul>
            <li>Kreirajte dobavljača jednom</li>
            <li>Koristite ga na svim lokacijama i skladištima</li>
          </ul>
        </details>

        <details>
          <summary>Kako promijeniti podatke dobavljača?</summary>
          <ol>
            <li>Idite na "Skladište" → "Dobavljači"</li>
            <li>Pronađite dobavljača</li>
            <li>Kliknite ikonu olovke <i class="mdi mdi-pencil" style="color: #3989C9; margin: 0 4px; font-size: 16px;"></i></li>
            <li>Izmjenite podatke</li>
            <li>Spremite</li>
          </ol>
        </details>

        <details>
          <summary>Mogu li obrisati dobavljača?</summary>
          <p>Brisanje nije uvijek moguće:</p>
          <ul>
            <li><i class="mdi mdi-close" style="color: #F44336; margin-right: 4px;"></i> Ne može se obrisati ako postoje primke od tog dobavljača</li>
            <li><i class="mdi mdi-check" style="color: #4CAF50; margin-right: 4px;"></i> <strong>Rješenje:</strong> Označite kao <span class="status-chip grey">Neaktivan</span></li>
          </ul>
        </details>

        <details>
          <summary>Što ako dobavljač promijeni cijene?</summary>
          <p>Ažurirajte katalog dobavljača:</p>
          <ol>
            <li>Otvorite dobavljača</li>
            <li>Idite na tab "Katalog"</li>
            <li>Ažurirajte cijene artikala</li>
            <li>Pri sljedećoj primci će biti vidljive nove cijene</li>
          </ol>
          <p>Stare primke zadržavaju originalne cijene.</p>
        </details>
      `
    },
    {
      id: 'warehouse-inventory',
      title: 'Inventura',
      icon: 'mdi-clipboard-list',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="what-is">Što je inventura?</h2>
        <p><strong>Inventura</strong> je proces fizičkog prebrojavanja stvarnog stanja artikala na skladištu i usporedbe s računovodstvenim stanjem u sustavu. Inventura otkriva razlike (viškove i manjkove) koje se zatim knjižno korigiraju.</p>

        <h2 id="when-to-use" class="mt-6">Kada raditi inventuru?</h2>
        <ul>
          <li><strong>Godišnja inventura</strong> - Obavezna prema zakonu (31.12. ili po zatvaranju godine)</li>
          <li><strong>Tromjesečna/mjesečna</strong> - Za bolju kontrolu zaliha</li>
          <li><strong>Parcijalna</strong> - Povremeno za određene kategorije</li>
          <li><strong>Hitna</strong> - Pri sumnji na krađu ili velike razlike</li>
          <li><strong>Početna</strong> - Pri postavljanju skladišnog modula</li>
        </ul>

        <h2 id="prerequisites" class="mt-6">Preduvjeti</h2>
        <ul>
          <li>Pristup "Skladište" → "Inventura"</li>
          <li>Dovoljno vremena (inventura zatvara skladišne operacije)</li>
          <li>Tim ljudi za prebrojavanje (za velike skladišta)</li>
        </ul>

        <h2 id="step-by-step" class="mt-6">Korak po korak</h2>

        <h3 class="mt-4">1. Priprema za inventuru</h3>
        <ol>
          <li><strong>Odaberite datum:</strong> Najbolje kraj mjeseca ili vikend</li>
          <li><strong>Obavijestite osoblje:</strong> Skladište će biti zatvoreno</li>
          <li><strong>Završite sve dokumente:</strong> Zatvorite sve otvorene primke/izdatnice</li>
          <li><strong>Pripremite pribor:</strong> Kalkulator, papir, olovka, scanner</li>
        </ol>

        <h3 class="mt-4">2. Kreiranje inventure u sustavu</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Inventura"</strong></li>
          <li>Kliknite <strong>"+ Nova inventura"</strong></li>
          <li>Odaberite tip:
            <ul>
              <li><strong>Potpuna</strong> - Svi artikli na skladištu</li>
              <li><strong>Parcijalna</strong> - Samo odabrane kategorije</li>
            </ul>
          </li>
          <li>Odaberite skladište</li>
          <li>Kliknite <strong>"Kreiraj"</strong></li>
        </ol>

        <h3 class="mt-4">3. Fizičko prebrojavanje</h3>
        <ol>
          <li>Sustav prikazuje listu svih artikala s trenutnim računovodstvenim stanjem</li>
          <li>Fizički prebrojite svaki artikl</li>
          <li>Unesite <strong>stvarno stanje</strong> u stupac "Inventurno stanje"</li>
          <li>Sustav automatski računa razliku (višak/manjak)</li>
        </ol>

        <table class="info-table">
          <thead>
            <tr>
              <th>Artikl</th>
              <th>Stanje u sustavu</th>
              <th>Prebrojano stanje</th>
              <th>Razlika</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Coca Cola 0.33L</td>
              <td>100 kom</td>
              <td>95 kom</td>
              <td><span style="color: #F44336;">-5 kom (manjak)</span></td>
            </tr>
            <tr>
              <td>Kava zrno 1kg</td>
              <td>20 kg</td>
              <td>22 kg</td>
              <td><span style="color: #4CAF50;">+2 kg (višak)</span></td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">4. Analiza razlika</h3>
        <p>Prije knjiženja, analizirajte značajne razlike:</p>
        <ul>
          <li><strong>Manjak:</strong> Provjera prodaje, otpis, moguća krađa, greška u popisivanju</li>
          <li><strong>Višak:</strong> Provjerite jeste li sve primke knjižili, greška u popisivanju</li>
          <li><strong>Mali odmaci (1-2%):</strong> Prihvatljivo zbog zaokruživanja</li>
          <li><strong>Veliki odmaci (>5%):</strong> Obavezna analiza i izvještaj</li>
        </ul>

        <h3 class="mt-4">5. Knjiženje inventure</h3>
        <ol>
          <li>Pregledajte sve razlike</li>
          <li>Dodajte napomenu za značajne razlike</li>
          <li>Kliknite <strong>"Knjižim"</strong></li>
          <li>Sustav automatski korigira stanja:
            <ul>
              <li>Višak → Automatska primka</li>
              <li>Manjak → Automatska izdatnica</li>
            </ul>
          </li>
          <li>Status: <span class="status-chip success">Knjiženo</span></li>
        </ol>

        <div class="warning-box">
          <i class="mdi mdi-alert" style="color: #FF9800; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Nakon knjiženja, računovodstveno stanje = stvarnom stanju. Inventura je nepovratna!
          </div>
        </div>

        <h2 id="tips" class="mt-6">Savjeti i trikovi</h2>
        <ul>
          <li><strong>Tim:</strong> Prebrojavanje u parovima (jedan broji, drugi zapisuje)</li>
          <li><strong>Redoslijed:</strong> Prebrojavajte sistematično (polica po polica)</li>
          <li><strong>Vrijeme:</strong> Radite kad nema prometa (rano ujutro ili kasno navečer)</li>
          <li><strong>Barcode:</strong> Koristite scanner za brže unos</li>
          <li><strong>Fotografije:</strong> Fotografirajte police prije prebrojavanje</li>
          <li><strong>Rotacija:</strong> Radite parcijalnu inventuru različitih kategorija svaki tjedan</li>
        </ul>

        <h2 id="troubleshooting" class="mt-6">Što ako...?</h2>

        <details>
          <summary>Našao sam velike razlike - što sad?</summary>
          <p>Ne knjižite odmah, već:</p>
          <ol>
            <li><strong>Ponovno prebrojite</strong> artikle s velikim razlikama</li>
            <li>Provjerite jesu li svi skladišni dokumenti knjiženi</li>
            <li>Provjerite jesu li prodaje preko blagajne ispravno evidentirane</li>
            <li>Analizirajte moguće uzroke (krađa, kvar, greška)</li>
            <li>Dokumentirajte razloge u napomenu inventure</li>
          </ol>
        </details>

        <details>
          <summary>Mogu li pauzirati inventuru i nastaviti sutra?</summary>
          <p>Da, inventura se može raditi u više sesija:</p>
          <ul>
            <li>Inventura ostaje u statusu <span class="status-chip warning">Nacrt</span></li>
            <li>Možete zatvoriti i nastaviti kasnije</li>
            <li>Sve uneseno se sprema</li>
            <li><strong>Ali:</strong> Dok inventura traje, ne bi trebali knjižiti primke/izdatnice</li>
          </ul>
        </details>

        <details>
          <summary>Slučajno sam knjižio inventuru s greškom?</summary>
          <p>Nakon knjiženja inventura se ne može mijenjati:</p>
          <ul>
            <li><strong>Rješenje 1:</strong> Napravite korekciju primkom ili izdatnicom</li>
            <li><strong>Rješenje 2:</strong> Kontaktirajte administratora za ručnu intervenciju</li>
            <li><strong>Najbolje:</strong> Uvijek dvaput provjerite prije knjiženja!</li>
          </ul>
        </details>

        <details>
          <summary>Trebam li zatvoriti skladište tijekom inventure?</summary>
          <p>Preporučeno je, ali ovisi o tipu:</p>
          <table class="info-table">
            <thead>
              <tr>
                <th>Tip</th>
                <th>Zatvaranje skladišta?</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td><strong>Potpuna inventura</strong></td>
                <td><span class="status-chip error">DA</span> - Obustava svih operacija</td>
              </tr>
              <tr>
                <td><strong>Parcijalna inventura</strong></td>
                <td><span class="status-chip warning">DJELOMIČNO</span> - Samo dio skladišta</td>
              </tr>
              <tr>
                <td><strong>Rotacijsika inventura</strong></td>
                <td><span class="status-chip success">NE</span> - Popisujete malu grupu artikala</td>
              </tr>
            </tbody>
          </table>
        </details>

        <details>
          <summary>Kako izvesti izvještaj inventure za računovodstvo?</summary>
          <ol>
            <li>Idite na "Skladište" → "Inventura"</li>
            <li>Pronađite knjiženu inventuru</li>
            <li>Kliknite "..." → "Izvezi PDF" ili "Ispiši"</li>
            <li>Izvještaj sadrži: datum, popisivače, razlike, ukupne vrijednosti</li>
            <li>Dostavite računovodstvu</li>
          </ol>
        </details>
      `
    },
    {
      id: 'warehouse-card',
      title: 'Skladišna kartica',
      icon: 'mdi-history',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="warehouse-card">Skladišna kartica</h2>
        <p>
          Skladišna kartica prikazuje kompletnu povijest kretanja artikla u skladištu:
          sve ulaze, izlaze i trenutno stanje zaliha.
        </p>

        <h3 class="mt-4">Pristup skladišnoj kartici</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Artikli"</strong></li>
          <li>Pronađite artikl</li>
          <li>Kliknite <i class="mdi mdi-file-document"></i> <strong>"Skladišna kartica"</strong></li>
        </ol>

        <h3 class="mt-4">Sadržaj kartice</h3>
        <table class="info-table">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Dokument</th>
              <th>Ulaz</th>
              <th>Izlaz</th>
              <th>Stanje</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>01.01.2024</td>
              <td>Početno stanje</td>
              <td>-</td>
              <td>-</td>
              <td>50 kom</td>
            </tr>
            <tr>
              <td>05.01.2024</td>
              <td>Primka PRI-001</td>
              <td>100 kom</td>
              <td>-</td>
              <td>150 kom</td>
            </tr>
            <tr>
              <td>10.01.2024</td>
              <td>Izdatnica IZD-001</td>
              <td>-</td>
              <td>80 kom</td>
              <td>70 kom</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Tipovi kretanja</h3>
        <ul>
          <li><strong>Primka (GRN)</strong> - Ulaz robe od dobavljača</li>
          <li><strong>Izdatnica (GIN)</strong> - Izlaz robe (prodaja, otpis)</li>
          <li><strong>Međuskladišnica</strong> - Prijenos između skladišta</li>
          <li><strong>Inventura</strong> - Usklađivanje stanja nakon popisa</li>
        </ul>

        <div class="info-box">
          <i class="mdi mdi-information" style="color: #3989C9; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Važno:</strong> Skladišna kartica prikazuje samo proknjižene dokumente.
            Dokumenti u statusu "Draft" nisu uključeni.
          </div>
        </div>
      `
    },
    {
      id: 'warehouse-norm',
      title: 'Normativ',
      icon: 'mdi-food',
      badge: { text: 'SA SKLADIŠTEM', color: 'primary' },
      content: () => `
        <h2 id="warehouse-norm">Normativ</h2>
        <p>
          Normativ je recept koji definira sastojke i količine potrebne za proizvodnju
          složenog proizvoda. Koristi se u restoranima, pekarama i proizvodnim pogonima.
        </p>

        <h3 class="mt-4">Primjer normativa</h3>
        <p><strong>Proizvod: Pizza Margherita</strong></p>
        <table class="info-table">
          <thead>
            <tr>
              <th>Sastojak</th>
              <th>Količina</th>
              <th>Jedinica</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Tijesto za pizzu</td>
              <td>250</td>
              <td>g</td>
            </tr>
            <tr>
              <td>Paradajz umak</td>
              <td>80</td>
              <td>g</td>
            </tr>
            <tr>
              <td>Mozzarella sir</td>
              <td>120</td>
              <td>g</td>
            </tr>
            <tr>
              <td>Bosiljak</td>
              <td>5</td>
              <td>g</td>
            </tr>
          </tbody>
        </table>

        <h3 class="mt-4">Kreiranje normativa</h3>
        <ol>
          <li>Idite na <strong>"Skladište" → "Normativi"</strong></li>
          <li>Kliknite <strong>"+ Dodaj normativ"</strong></li>
          <li>Odaberite gotovi proizvod</li>
          <li>Dodajte sastojke s količinama</li>
          <li>Spremite normativ</li>
        </ol>

        <h3 class="mt-4">Kalkulacija troškova</h3>
        <p>Sustav automatski kalkulira cijenu proizvoda prema nabavnim cijenama sastojaka:</p>
        <ul>
          <li>Trošak sirovina = zbroj (količina × nabavna cijena sastojka)</li>
          <li>Dodajte režijske troškove (%)  </li>
          <li>Dodajte maržu za prodajnu cijenu</li>
        </ul>

        <div class="success-box">
          <i class="mdi mdi-lightbulb" style="color: #4CAF50; margin-right: 8px; font-size: 20px;"></i>
          <div>
            <strong>Savjet:</strong> Redovito ažurirajte normative prilikom promjene receptura
            ili nabavnih cijena sirovina za točnu kalkulaciju troškova.
          </div>
        </div>
      `
    }
  ]
}
